<template>
  <div>
    <login v-bind="loginProps"></login>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import login from '@/components/views/login';
import { getUrlParam } from '@/utils';
export default {
  components: {
    login
  },
  mounted() {
    this.checkEnv();
    this.eventLog();
  },
  computed: {
    ...mapState('app', ['loginConfig']),
    //  判断是否是小拉用的受邀者 登陆
    isXlInvitedLogin() {
      let inviteUserType = getUrlParam('inviteUserType');
      return getUrlParam('bl') === '8' && inviteUserType;
    },
    //  处理登陆页面的配置信息
    loginProps() {
      console.log(this.isXlInvitedLogin, 'isXlInvitedLogin');
      let {
        config = {
          pageConfig: {
            headImage: '',
            backgroundColor: ''
          }
        }
      } = this.loginConfig || {};
      return this.isXlInvitedLogin && this.loginConfig
        ? {
            bannerPoster: config.pageConfig.headImage,
            backgroundColor: config.pageConfig.backgroundColor
          }
        : {
            bannerPoster: '',
            backgroundColor: ''
          };
    }
  },
  async created() {
    await this.loadLocationData();
    if (this.isXlInvitedLogin) {
      await this.fetchLoginInfo();
    }
  },
  methods: {
    ...mapMutations('global', ['set_env']),
    ...mapActions('app', ['fetchLoginInfo', 'loadLocationData']),
    checkEnv() {
      let { user_type } = this.$route.query;
      if (user_type) {
        this.set_env(user_type);
      }
    },
    eventLog() {
      let inviteUserType = getUrlParam('inviteUserType');
      console.log(inviteUserType, 'inviteUserType+++++');
      this.trackLog('登录', true, {
        actEventType: inviteUserType ? 'invited_login' : 'invite_login'
      });
    }
  }
};
</script>
